import { Flame, Zap, BatteryLow, HeartOff, CloudRain, Wind } from "lucide-react";
import { moodById } from "@/lib/constants";

const ICONS = { Flame, Zap, BatteryLow, HeartOff, CloudRain, Wind };

export default function MoodBadge({ moodId, size = "sm" }) {
  const m = moodById(moodId);
  const Icon = ICONS[m.icon] || Flame;
  const px = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${px}`}
      style={{ background: m.bg, color: m.color, border: `1px solid ${m.color}40` }}
      data-testid={`mood-badge-${moodId}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {m.label}
    </span>
  );
}
